import { createSelector } from 'reselect';

export const draftSelector = state => state.draft;

export const draftDataSelector = createSelector(
  draftSelector,
  subState => subState.data
);

export const draftDateSelector = createSelector(
  draftSelector,
  subState => subState.timestamp
);

export const draftLoadedVersionDateSelector = createSelector(
  draftSelector,
  subState => subState.loadedVersionDate
);

export const draftLoadingSelector = createSelector(
  draftSelector,
  subState => subState.loading
);

export const draftDeletedSelector = createSelector(
  draftSelector,
  subState => subState.deleted
);

export const draftErrorSelector = createSelector(
  draftSelector,
  subState => subState.error
);
